import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type KnowledgeBase } from "./types";

type Props = {
  articleCategories: KnowledgeBase.Api.ArticleCategory[];
  activeItem: KnowledgeBase.View.ActiveItem;
  onCategoryClick: (category: KnowledgeBase.Api.ArticleCategory | null) => void;
};
export default ({ articleCategories, activeItem, onCategoryClick }: Props) => {
  const i18n = useI18n();

  const items = React.useMemo(() => {
    let currentCat =
      activeItem?.type === "category"
        ? activeItem.category
        : articleCategories.find((c) => c.articleCategoryId === activeItem.article!.articleCategoryId)!;

    const result = [currentCat];
    while (currentCat!.parentArticleCategoryId) {
      currentCat = articleCategories.find((c) => c.articleCategoryId === currentCat!.parentArticleCategoryId)!;
      result.push(currentCat);
    }

    return result.reverse();
  }, [articleCategories, activeItem]);

  return (
    <div className="breadcrumbs">
      <a className="breadcrumbs_item" onClick={() => onCategoryClick(null)}>
        {i18n.knowledgeBase}
      </a>
      <span>{">"}</span>
      {items
        .map((category) =>
          activeItem.type === "category" && activeItem.category.articleCategoryId === category.articleCategoryId ? (
            <span key={category!.articleCategoryId} className="breadcrumbs_item">
              {category!.name}
            </span>
          ) : (
            <a
              key={category!.articleCategoryId}
              className="breadcrumbs_item"
              onClick={() => onCategoryClick(category!)}
            >
              {category!.name}
            </a>
          )
        )
        .flatMap((x) => [<span>{">"}</span>, x])
        .slice(1)}
      {activeItem?.type === "article" && (
        <>
          <span>{">"}</span>
          <span className="breadcrumbs_item">{activeItem.article!.title}</span>
        </>
      )}
    </div>
  );
};
